import ExpertCard from "../components/modules/experts/ExpertCard";
import expertsData from "../data/expertsData";

export default function Experts() {
  return (
    <div>
      <div className="bg-gradient-to-br from-[#1e1b4b] via-[#312e81] to-[#4c1d95] text-white rounded-2xl px-5 py-8 sm:px-8 sm:py-10 mb-6">
        <span className="inline-block text-xs font-semibold bg-white/10 border border-white/20 rounded-full px-4 py-1.5 mb-4">
          Expert Marketplace
        </span>
        <h1 className="text-2xl sm:text-3xl md:text-4xl font-extrabold mb-2">
          Consult 260+ Industry Experts
        </h1>
        <p className="text-indigo-100 max-w-2xl text-sm sm:text-base">
          Book time with domain leaders across additive manufacturing,
          robotics, EV, PCB and more.
        </p>
      </div>

      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5 sm:gap-6">
        {expertsData.map((expert) => (
          <ExpertCard key={expert.name} expert={expert} />
        ))}
      </div>
    </div>
  );
}